export default __webpack_public_path__ + "static/media/companies-experts-priority-attention.06be677a.svg";